import { motion } from "framer-motion";

const ease = [0.22, 1, 0.36, 1];
const VIEW = { once: true, amount: 0.15 };

export const Reveal = ({ children, delay = 0, y = 28, className = "", as = "div", ...rest }) => {
  const C = motion[as];
  return (
    <C className={className} initial={{ opacity: 0, y }} whileInView={{ opacity: 1, y: 0 }} viewport={VIEW}
      transition={{ duration: 1.1, ease, delay }} {...rest}>
      {children}
    </C>
  );
};

export const Stagger = ({ children, className = "", gap = 0.12, ...rest }) => (
  <motion.div className={className} initial="hidden" whileInView="show" viewport={VIEW}
    variants={{ hidden: {}, show: { transition: { staggerChildren: gap } } }} {...rest}>
    {children}
  </motion.div>
);

export const StaggerItem = ({ children, className = "", ...rest }) => (
  <motion.div className={className} variants={{ hidden: { opacity: 0, y: 24 }, show: { opacity: 1, y: 0, transition: { duration: 1, ease } } }} {...rest}>
    {children}
  </motion.div>
);

// Image reveal: observer on unclipped wrapper, the inner image settles from a slight zoom.
export const RevealImage = ({ src, alt, className = "", imgClassName = "", eager = false, ...rest }) => (
  <motion.div className={`overflow-hidden ${className}`} initial="hidden" whileInView="show" viewport={VIEW} {...rest}>
    <motion.img src={src} alt={alt} loading={eager ? "eager" : "lazy"} decoding="async"
      className={`h-full w-full object-cover ${imgClassName}`}
      variants={{ hidden: { scale: 1.14, opacity: 0.4 }, show: { scale: 1, opacity: 1, transition: { duration: 1.8, ease } } }} />
  </motion.div>
);

export const MaskLines = ({ lines, className = "", delay = 0, lineClass = "" }) => (
  <span className={className}>
    {lines.map((l, i) => (
      <span key={l} className="block overflow-hidden pb-[0.08em]">
        <motion.span className={`block ${lineClass}`} initial={{ y: "110%" }} animate={{ y: "0%" }}
          transition={{ duration: 1.3, ease, delay: delay + i * 0.14 }}>
          {l}
        </motion.span>
      </span>
    ))}
  </span>
);
